import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { FileText, UserCheck, AlertCircle, Scale } from 'lucide-react';
import './PrivacyPolicy.css'; // Reusing the same styling for consistency

const TermsOfService = () => {
    return (
        <motion.div
            className="legal-page"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            <Helmet>
                <title>Terms of Service | Kodebuild</title>
                <meta name="description" content="Kodebuild's Terms of Service outlines the rules and regulations for the use of our website." />
                <link rel="canonical" href="https://kodebuildtech.com/terms" />
            </Helmet>
            <div className="container">
                <header className="legal-header">
                    <h1>Terms of Service</h1>
                    <p>Last Updated: March 1, 2026</p>
                </header>

                <div className="legal-content">
                    <section>
                        <div className="legal-icon-title">
                            <Scale className="legal-icon" />
                            <h2>1. Agreement to Terms</h2>
                        </div>
                        <p>
                            These Terms of Service constitute a legally binding agreement made between you, whether personally or on
                            behalf of an entity (“you”) and Kodebuild (“we,” “us” or “our”), concerning your access to and use of
                            the website as well as any other media form, media channel, mobile website or mobile application
                            related, linked, or otherwise connected thereto.
                        </p>
                    </section>

                    <section>
                        <div className="legal-icon-title">
                            <UserCheck className="legal-icon" />
                            <h2>2. Intellectual Property Rights</h2>
                        </div>
                        <p>
                            Unless otherwise indicated, the Site is our proprietary property and all source code, databases,
                            functionality, software, website designs, audio, video, text, photographs, and graphics on the
                            Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein
                            (the “Marks”) are owned or controlled by us or licensed to us.
                        </p>
                    </section>

                    <section>
                        <div className="legal-icon-title">
                            <FileText className="legal-icon" />
                            <h2>3. User Representations</h2>
                        </div>
                        <p>
                            By using the Site, you represent and warrant that: (1) all registration information you submit will
                            be true, accurate, current, and complete; (2) you will maintain the accuracy of such information
                            and promptly update such registration information as necessary; (3) you have the legal capacity
                            and you agree to comply with these Terms of Service.
                        </p>
                    </section>

                    <section>
                        <div className="legal-icon-title">
                            <AlertCircle className="legal-icon" />
                            <h2>4. Prohibited Activities</h2>
                        </div>
                        <p>
                            You may not access or use the Site for any purpose other than that for which we make the Site
                            available. The Site may not be used in connection with any commercial endeavors except those
                            that are specifically endorsed or approved by us.
                        </p>
                    </section>

                    <section className="legal-booster">
                        <div className="legal-icon-title">
                            <Scale className="legal-icon" />
                            <h2>6. Engineering Integrity</h2>
                        </div>
                        <p>
                            At Kodebuild, we take pride in the quality and integrity of our work. Our "Innovative in every Byte" 
                            philosophy ensures that we deliver systems that are not only functional but also scalable and maintainable. 
                            By using our website and services, you join a community that values technical excellence and professional 
                            standards in software engineering.
                        </p>
                    </section>
                </div>
            </div>
        </motion.div>
    );
};

export default TermsOfService;
